import { useToastContext } from 'Context/ToastContext';

export const useToast = () => useToastContext();
